import { createFileRoute } from "@tanstack/react-router";
import AdminQuiz from "@/pages/admin/AdminQuiz";

export const Route = createFileRoute("/admin/quiz")({ component: AdminQuiz });
